import { Box, Flex, Spinner, Text } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { getMonthlyReportPivotTypeOfSupport } from "../../../Http/Index"
import { PivotTable } from "./PivotTable"

interface Props {
  selectedMonth: string
  selectedCompanyId?: string
}

export const TypeOfSupport: React.FC<Props> = ({
  selectedMonth,
  selectedCompanyId = "",
}) => {
  const [data, setData] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMonth, selectedCompanyId])

  const fetchData = async () => {
    setIsLoading(true)
    try {
      const params: Record<string, any> = {}
      if (selectedCompanyId) params.companyId = selectedCompanyId
      const res = await getMonthlyReportPivotTypeOfSupport(selectedMonth, params)
      setData(res.data?.data || [])
    } catch {
    } finally {
      setIsLoading(false)
    }
  }

  // derive unique quarters from data
  const quarters = data
    .flatMap((item: any) => (item.quarters || []).map((q: any) => q.quarter))
    .filter((v, i, a) => v && a.indexOf(v) === i)

  const SUPPORT_TYPE_ORDER = [
    "End to End support",
    "End to End w/o Dr Consult",
    "Emergency doctor Consult",
    "Insurance Support",
    "Cancelled / Other",
  ]

  const rows = data
    .map((item: any) => ({
      rowLabel: item._id || "Cancelled / Other",
      values: Object.fromEntries(
        (item.quarters || []).map((q: any) => [q.quarter, q.count])
      ),
      total: item.total,
    }))
    .sort((a, b) => {
      const idxA = SUPPORT_TYPE_ORDER.indexOf(a.rowLabel)
      const idxB = SUPPORT_TYPE_ORDER.indexOf(b.rowLabel)
      if (idxA !== -1 && idxB !== -1) return idxA - idxB
      if (idxA !== -1) return -1
      if (idxB !== -1) return 1
      return a.rowLabel.localeCompare(b.rowLabel)
    })

  return (
    <Box mt={2}>
      {isLoading ? (
        <Flex justify="center" py={10}><Spinner /></Flex>
      ) : rows.length === 0 ? (
        <Text color="gray.400" textAlign="center" py={6}>No data</Text>
      ) : (
        <PivotTable rows={rows} columns={quarters} />
      )}
    </Box>
  )
}
